import { observable, action, computed } from "mobx";
import { ServiceInterface } from "../service.interface";
import {
  NetInfoAdapterInterface,
  NetInfoState,
  NetInfoSubscription,
} from "./net-info-adapter.interface";
import { createContext } from "react";

export const ReachabilityServiceContext = createContext<ReachabilityService>(
  null as any
);

export class ReachabilityService implements ServiceInterface {
  public context = ReachabilityServiceContext;

  constructor(private netInfoAdapter: NetInfoAdapterInterface) {}

  @observable
  private _reachable = false;

  @computed
  public get reachable() {
    return this._reachable;
  }

  @action
  private setReachable = (value: boolean | undefined | null) => {
    this._reachable = !!value;
  };

  private subscription?: NetInfoSubscription;

  public serviceWillMount() {
    this.subscription = this.netInfoAdapter.addEventListener(this.stateUpdate);
  }

  public serviceDidBecomeForeground() {
    this.netInfoAdapter.fetch().then(this.stateUpdate);
  }

  public serviceWillUnmount() {
    this.subscription && this.subscription();
  }

  private stateUpdate = (state: NetInfoState) => {
    this.setReachable(state.isInternetReachable);
  };
}
